import { Layout, Showcase, Grid, GridItem, UseCase, Header } from "../../../../src/components";
import { FaCheck, FaTimes } from 'react-icons/fa';
import Changelog from "../../../../src/pages/wt/general/(deprecated) changelog/changelog.js";
import changelog from "../../../../src/data/changelog.json";
import data from "../../../../src/pages/wt/general/(deprecated) changelog/data.json";
import "../../../../src/pages/wt/general/(deprecated) changelog/style.scss";
import * as React from 'react';
export default {
  Layout,
  Showcase,
  Grid,
  GridItem,
  UseCase,
  Header,
  FaCheck,
  FaTimes,
  Changelog,
  changelog,
  data,
  React
};